import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.map.js";
import React from 'react';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Modal from 'components/Modal';
import Button from 'components/Button';
import InlineList from 'components/InlineList';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';
function SimpleModal(_ref) {
  var buttons = _ref.buttons,
    children = _ref.children,
    id = _ref.id,
    onClose = _ref.onClose,
    title = _ref.title,
    subtitle = _ref.subtitle,
    body = _ref.body,
    width = _ref.width;
  var titleId = useUniqueId(id);
  return /*#__PURE__*/React.createElement(Modal, {
    id: "".concat(titleId, "-modal"),
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    width: width
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: title,
    titleId: titleId,
    onClose: onClose,
    subtitle: subtitle
  }), /*#__PURE__*/React.createElement(Panel, null, body), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, children ? children : /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs"
  }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: button.label
    }, button), button.label);
  })))));
}
export default SimpleModal;